interface ShouldShowAddressNoResultsParams {
  addressInput: string;
  requestedAddress: string;
  isLoading: boolean;
  hasResponse: boolean;
  suggestionCount: number;
}

export function shouldShowAddressNoResults({
  addressInput,
  requestedAddress,
  isLoading,
  hasResponse,
  suggestionCount,
}: ShouldShowAddressNoResultsParams): boolean {
  const normalizedAddress = addressInput.trim();

  return (
    normalizedAddress.length >= 3 &&
    requestedAddress === normalizedAddress &&
    !isLoading &&
    hasResponse &&
    suggestionCount === 0
  );
}
